import {
    legacy_createStore as createStore,
    applyMiddleware,
    compose
} from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers';
import { thunk } from 'redux-thunk';
import { api } from './middleware';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
const middlewares = [thunk, api];
const composeEnhancer = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancers = composeEnhancer(applyMiddleware(...middlewares));

const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: hardSet,
    //blackList:[authenticate]
    blacklist: []
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(pReducer, enhancers);
export const persistor = persistStore(store);
